$('.slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1000,
  fade: true,
  autoplay: true,
  autoplaySpeed: 1500,
  pauseOnHover: true
});


$('.responsive-slider').each (function(){

  const numSlides = $(this).find('.responsive-slider__slide').length;

  const slickOptions = {
    dots: false,
    infinite: true,
    speed: 300,
    rows: (numSlides > 5 ? 2 : 1),
    slidesToShow: (numSlides > 2 ? 5 : 2),
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1550,
        settings: {
          rows: (numSlides > 4 ? 2 : 1),
          slidesToShow: (numSlides > 3 ? 4 : 3),
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1390,
        settings: {
          rows: (numSlides > 3 ? 2 : 1),
          slidesToShow: (numSlides > 3 ? 3 : 3),
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 1000,
        settings: {
          rows: (numSlides > 3 ? 2 : 1),
          slidesToShow: (numSlides > 3 ? 2 : 1),
          slidesToScroll: (numSlides > 3 ? 2 : 1)
        }
      }
    ]
  };

  $(this).slick(slickOptions);

  //check if there are more than 3 elements
  if (numSlides <= 3) {
    //if so get the last 2 elements and add the class
    $(this).addClass("two-item-slider");
  }

  //check if there are more than 5 elements
  if (numSlides < 6) {
    //if so get the last 2 elements and add the class
    $(this).addClass("single-row-slider");
  }

  // $(this).addClass("single-row-slider");

})



$('.cutoff-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  // centerMode: true,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.partner-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1700,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1030,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 780,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});